module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter01#ch01"
    }
  }, [_c('i', [_vm._v("1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/10_Chapter01#ch01"
    }
  }, [_c('i', [_vm._v("Waving")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter02#ch02"
    }
  }, [_c('i', [_vm._v("2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/11_Chapter02#ch02"
    }
  }, [_c('i', [_vm._v("Performance")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("On the sidelines")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Death of a spinster")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The prisoner")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Homecoming")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("At the bar")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("In the steps of Spartacus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sentences")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Getting along")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Mick’s day")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Tig")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Beached")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How many miles to Babylon?")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("15")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Callers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("End game")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("17")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Hullo again")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Holing out")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Deathwatch beetle")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("20")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Dreaming")])])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07138e62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_Toc.vue
// module id = 72
// module chunks = 0